<template>
  <div id="app">
    <!--处理沉浸式交互-->
    <div v-if="!$route.meta.fullScreen" class="fullScreen" />
    <!--内容区域-->
    <div class="app-box-wrap">
      <hn-nav-bar
        v-if="[1, 3].includes($route.meta.layout)"
        v-bind="$route.meta"
      />
      <router-view class="content" />
      <Footer v-if="[2, 3].includes($route.meta.layout)" />
    </div>
  </div>
</template>
<script>
import { Footer } from './layout/components/index'
export default {
  components: {
    Footer
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  .app-box-wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    // transform: scale(1);
    padding-bottom: constant(safe-area-inset-bottom); /*兼容 IOS<11.2*/
    padding-bottom: env(safe-area-inset-bottom); /*兼容 IOS>11.2*/
    .content {
      flex: 1;
    }
  }
  .fullScreen {
    width: 100%;
    height: var(--top-safearea);
  }
}
.omt {
  overflow: hidden; //隐藏
  white-space: nowrap; //不换行
  text-overflow: ellipsis; //超出部分省略号
}
.fixwh {
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
